<template>
    <div v-click-outside="close" class="ds-date-range-filter">
        <button type="button" class="ds-date-range-filter-trigger" :class="{ 'ds-date-range-filter-trigger-active': hasFullRange }" @click.stop="toggle">
            <icon class="ds-date-range-filter-icon"><IconSort width="16" height="16" /></icon>
        </button>

        <div v-if="isOpen" class="ds-date-range-filter-popover">
            <AppCalendar
                :model-value="date"
                mode="range"
                @update:model-value="onSelect"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import type { Dayjs } from 'dayjs'
import AppCalendar from '@/ui/AppCalendar.vue'
import IconSort from '@/ui/icons/IconSort.vue'

const props = withDefaults(defineProps<{ modelValue?: [Dayjs, Dayjs] | null }>(), { modelValue: null })
const emit = defineEmits<{
    selected: [value: [Dayjs, Dayjs]]
    'update:modelValue': [value: [Dayjs, Dayjs] | null]
}>()

const isOpen = ref(false)
const date = ref<[Dayjs, Dayjs] | null>(null)
const hasFullRange = computed(() => Boolean(date.value?.[0] && date.value?.[1]))

watch(() => props.modelValue, value => { date.value = value }, { immediate: true })

function toggle() {
    if (isOpen.value) close()
    else isOpen.value = true
}

function onSelect(value: Dayjs | [Dayjs, Dayjs] | Dayjs[]) {
    date.value = value as [Dayjs, Dayjs]
}

function close() {
    if (!isOpen.value) return
    isOpen.value = false
    const [start, end] = date.value ?? []
    if (start && end) {
        emit('update:modelValue', [start, end])
        emit('selected', [start, end])
    }
}
</script>
